import { useDownload } from '../hooks';
var DOWNLOAD_TEMPLATE_API = '/api/report/template/export';
export var useDownloadTemplateAPI = function (shouldDownload) {
    if (shouldDownload === void 0) { shouldDownload = true; }
    return useDownload(DOWNLOAD_TEMPLATE_API, 'Template.xlsx', { method: 'POST', shouldDownload: shouldDownload });
};
